module.exports = __webpack_public_path__ + "img/Diving.417db7fc.png";